import { SearchMode } from 'src/types/search'
import styles from './styles.module.css'

export const searchModeClasses: Record<SearchMode, string> = {
  [SearchMode.Readonly]: styles.readonly,
  [SearchMode.Full]: styles.full,
  [SearchMode.Borderless]: styles.borderless,
}

export const getSearchModeClass = (searchMode: SearchMode): string => {
  return searchModeClasses[searchMode]
}
